<div class="pnl-cookies-policy">
  <app-cookies-policy-template></app-cookies-policy-template>
</div>
